module.exports = __webpack_public_path__ + "static/media/about-icon-measure.268d2a42.svg";